<script setup lang="ts">
import { useCreateCampaignRequest } from '@/api'
import CampaignForm from '@/components/CampaignForm/CampaignForm.vue'
import HeaderComponent from '@/components/Navigation/HeaderComponent.vue'
import { notification } from '@/lib/helpers'
import { useBackToPreviousPage } from '@/lib/hooks/back-to-previous-page.hooks'
import type { CampaignFormType } from '@/lib/types/campaign.types'
import { useUserStore } from '@/stores/user'
import { LoadingComponent } from '@/ui-library'

const userStore = useUserStore()
const handleBack = useBackToPreviousPage({ name: 'campaigns' })
const { createCampaign, isLoading, error } = useCreateCampaignRequest()

const onCampaignCreate = async (data: CampaignFormType) => {
  await createCampaign(data)
  if (!error.value) {
    await handleBack()
    notification.success('The campaign was created successfully')
  }
}
</script>

<template>
  <HeaderComponent />
  <LoadingComponent v-if="userStore.isLoading" :size="64" :is-full-size="true" />
  <template v-if="userStore.user">
    <CampaignForm
      :is-loading="isLoading"
      :error="error"
      :default-advertiser-group-id="userStore.user.storeGroupId"
      @handle-submit="onCampaignCreate"
    />
  </template>
</template>
